import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { FlightSeatLinkCard } from './ui/flight_seat_link.js';

export { FlightSeatLinkCard } from './ui/flight_seat_link.js';

/**
 * Entrada de catálogo do `flight_seat_link` (slot chat). Policy:
 *  - `freezeWhenSupersededBy: []`: o shell congela por POSIÇÃO (`frozenByThread` no
 *    `MessageRow` do web-chat); a lista vazia diz "nenhum sucessor congela". O botão só
 *    navega (`open-trip`, client-side, sem turno nem challenge) — vale depois de qualquer resposta.
 *  - `reconcileById: false`: o id é estável por kind; reconciliando, a 2ª resposta seria
 *    desenhada na linha da 1ª. Cada emissão ancora na própria mensagem.
 */
export const flightSeatLinkEntry: GenUiEntry<Extract<ChatUi, { kind: 'flight_seat_link' }>> = {
  kind: 'flight_seat_link',
  slot: 'chat',
  policy: { reconcileById: false, freezeWhenSupersededBy: [] },
  render: ({ ui, readOnly, dispatch }) => (
    <FlightSeatLinkCard flights={ui.flights} readOnly={readOnly} dispatch={dispatch} />
  ),
};
